"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.interpretErrorTypePreffix = exports.getMaxCapacity = exports.INITIAL_CAPACITY = void 0;
var getMaxCapacity = exports.getMaxCapacity = function getMaxCapacity(data) {
  return Math.max(data.usagePct.cpuUsage, data.usagePct.memoryUsage, data.usagePct.storageUsage, data.usagePct.gpuMemoryUsage, data.usagePct.gpuUtilization, data.usagePct.gpuEncoderUsage, data.usagePct.gpuDecoderUsage);
};
var INITIAL_CAPACITY = exports.INITIAL_CAPACITY = {
  usageLevel: "USAGE_LEVEL_1",
  alertMessage: "",
  usagePct: {
    cpuUsage: 0,
    memoryUsage: 0,
    storageUsage: 0,
    gpuMemoryUsage: 0,
    gpuUtilization: 0,
    gpuEncoderUsage: 0,
    gpuDecoderUsage: 0
  }
};

// "veo is dumb", so have to guess here
var interpretErrorTypePreffix = exports.interpretErrorTypePreffix = function interpretErrorTypePreffix(error) {
  var isGenetecSource = function isGenetecSource() {
    var haystack = "".concat(error.errorData || "", " ").concat(error.debugData || "", " ").concat(error.media || "").toLowerCase();
    return haystack.includes("genetec");
  };
  var isMilestoneSource = function isMilestoneSource() {
    var haystack = "".concat(error.errorData || "", " ").concat(error.debugData || "", " ").concat(error.media || "").toLowerCase();
    return haystack.includes("milestone");
  };
  var isUrlBasedSource = function isUrlBasedSource() {
    if (!error.media) {
      return false;
    }
    var media = error.media.toLowerCase();
    return media.startsWith("rtsp") || media.startsWith("http") || media.startsWith("rtp");
  };
  var isUrlPipeline = function isUrlPipeline() {
    if (!error.debugData) {
      return false;
    }
    var debug = error.debugData.toLowerCase();
    return debug.includes("gstsouphttpsrc.c") || debug.includes("gstrtspsrc.c");
  };
  if (error.debugData && error.debugData.toLowerCase().includes("pulsesrc.c")) {
    return "AUDIO_";
  }
  if (error.playerType === "SOURCE") {
    if (isUrlBasedSource()) {
      if (isGenetecSource()) {
        return "SOURCE_GENETEC_URL_";
      }
      if (isMilestoneSource()) {
        return "SOURCE_MILESTONE_URL_";
      }
      return "SOURCE_URL_";
    }
    return "SOURCE_";
  }
  if (error.errorType === "MEDIA_ERROR") {
    return "";
  }
  if (error.errorType !== "PIPELINE_ERROR") {
    return "";
  }
  if (isUrlPipeline()) {
    if (isGenetecSource()) {
      return "GENETEC_URL_";
    }
    if (isMilestoneSource()) {
      return "MILESTONE_URL_";
    }
    return "URL_";
  }
  return "";
};